The conflict result for the `updateUploadedCandidatePerson` mutation.
